import { tokenPrefix } from '@hivewatch/dark'

type ColorScheme = 'dark' | 'light'

export const darkCheckPointsPanelStyles = (colorScheme: ColorScheme) => {
  const prefix = tokenPrefix(colorScheme)
  return {
    headerTitle: {
      color: `${prefix}text.primary`,
      textStyle: 'heading',
    },
    headerDescription: {
      color: `${prefix}text.secondary`,
      textStyle: 'caption',
    },
    header: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
    },
    headerButtons: {
      display: 'flex',
      gap: '8px',
      pt: '8px',
      width: '100%',
    },
    listBody: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
    },
    filterRow: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    toggleRow: {
      alignItems: 'center',
      display: 'flex',
      gap: '8px',
    },
    toggleLabel: {
      color: `${prefix}text.secondary`,
      fontFamily: "'Soehne', sans-serif",
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '16px',
    },
    sectionTitle: {
      color: `${prefix}text.primary`,
      pt: '8px',
      textStyle: 'body-bold',
    },
    list: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
    },
    row: {
      alignItems: 'center',
      display: 'flex',
      gap: '8px',
      width: '100%',
    },
    rowItem: {
      flex: 1,
      minWidth: 0,
    },
    emptySection: {
      color: `${prefix}text.secondary`,
      fontFamily: "'Soehne', sans-serif",
      fontSize: '13px',
      fontWeight: '400',
      lineHeight: '16px',
    },
    emptyList: {
      color: `${prefix}text.secondary`,
      fontFamily: "'Soehne', sans-serif",
      fontSize: '14px',
      fontWeight: '500',
      py: '24px',
      textAlign: 'center' as const,
    },
    editHeaderRow: {
      alignItems: 'center',
      display: 'flex',
      gap: '8px',
      justifyContent: 'space-between',
    },
    editForm: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '12px',
    },
    editSectionLabel: {
      color: `${prefix}text.secondary`,
      pt: '4px',
      textStyle: 'label',
    },
    checklist: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '12px',
      pt: '16px',
    },
    checklistHeader: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
    checklistTitle: {
      color: `${prefix}text.primary`,
      textStyle: 'body-bold',
    },
    checklistLabel: {
      color: `${prefix}text.primary`,
      fontFamily: "'Soehne', sans-serif",
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '20px',
    },
    checklistRow: {
      alignItems: 'center',
      display: 'flex',
      gap: '8px',
    },
    checklistError: {
      color: `${prefix}status.error`,
      textStyle: 'caption',
    },
    checklistEmpty: {
      color: `${prefix}text.secondary`,
      textAlign: 'center' as const,
      textStyle: 'caption',
    },
    qrFrame: {
      alignItems: 'center',
      border: '1px solid',
      borderColor: `${prefix}border.default`,
      cursor: 'pointer',
      display: 'flex',
      gap: '16px',
      p: '16px',
      _hover: { bg: `${prefix}bg.table-row-hover` },
    },
    qrCanvasWrap: {
      // The canvas stays black-on-white so the code remains scannable; only the
      // chrome around it follows the theme.
      bg: 'white',
      flexShrink: 0,
      p: '8px',
      position: 'relative' as const,
    },
    qrDownloadOverlay: {
      alignItems: 'center',
      // Sits on the fixed-white canvas, so it is a light context whatever the
      // app theme is — hence the light tokens rather than the scheme's.
      bg: 'light.bg.overlay',
      bottom: 0,
      display: 'flex',
      justifyContent: 'center',
      left: 0,
      position: 'absolute' as const,
      right: 0,
      top: 0,
    },
    qrMeta: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '4px',
    },
    qrDisplayId: {
      color: `${prefix}text.secondary`,
      textStyle: 'caption',
    },
    qrDownloadLabel: {
      color: `${prefix}text.primary`,
      textStyle: 'body',
    },
    editFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
  }
}
